<div class="success-page-container">
    <div class="success-page-header">
        <button mat-icon-button class="close-button" (click)="closePage()" aria-label="Закрыть">
            <mat-icon class="close-icon">close</mat-icon>
        </button>
    </div>

    <div class="success-page-wrapper">
        <!-- <div *ngIf="!paymentInitialized && !paymentError" class="loading-indicator"></div> -->
        <p>Счёт оплачен</p>
    </div>

    <div class="waiter-info" *ngIf="waiter; else padding">
        <div class="waiter-info-details" [ngStyle]="{'padding-bottom': waiter.target ? '8px' : '0px'}">
            <div class="waiter-name-smile">
                <span class="waiter-name">{{ waiter.name }}</span>
                <span class="waiter-smile">Спасибо за чаевые ☺️</span>
            </div>
            <img class="waiter-avatar" [src]="waiter.image || 'assets/no_photo_ru.png'" alt="{{ waiter.name }}"
                (error)="onImageError($event)">
        </div>
    </div>
    <ng-template #padding>
        <div class="footer-dialog-padding"></div>
    </ng-template>
</div>